import useTestId from '@ori/testid-generator';
import { lazy, useMemo } from 'react';
import { useGetProductShades } from '../../api';
import { ShadePickerProvider } from '../../contexts';
import { useTranslations } from '../../hooks';
import { shouldFetchShades } from '../../utils/shouldFetchShades';
import { Loading } from '../Loading';
import { SHADE_PICKER_DIALOG, transitionProps } from './constants';
import { Dialog } from './styles';
import { jsx as _jsx } from "react/jsx-runtime";
const ShadePickerContent = /*#__PURE__*/lazy(async () => ({
  default: (await import('../ShadePickerContent')).ShadePickerContent
}));
/**
 * Shows Shade Picker dialog.
 */
export const ShadePickerDialog = ({
  mode,
  open,
  onClose,
  goToUrl,
  products,
  productName,
  placement,
  productCode
}) => {
  const {
    getTestId
  } = useTestId();
  const {
    translations
  } = useTranslations();
  const enabled = shouldFetchShades({
    productCode,
    products
  });
  const {
    loading,
    data
  } = useGetProductShades({
    productCode,
    enabled
  });
  const value = useMemo(() => ({
    mode,
    placement,
    productCode,
    goToUrl: enabled ? data?.goToUrl : goToUrl,
    products: enabled ? data?.products : products,
    productName: enabled ? data?.productName : productName
  }), [mode, placement, productCode, enabled, data?.goToUrl, data?.products, data?.productName, goToUrl, products, productName]);
  return /*#__PURE__*/_jsx(ShadePickerProvider, {
    value: value,
    children: /*#__PURE__*/_jsx(Dialog, {
      "data-testid": getTestId(SHADE_PICKER_DIALOG),
      open: open,
      transitionProps: transitionProps,
      header: translations.chooseShade,
      onClose: onClose,
      children: enabled && loading ? /*#__PURE__*/_jsx(Loading, {}) : /*#__PURE__*/_jsx(ShadePickerContent, {})
    })
  });
};
//# sourceMappingURL=ShadePickerDialog.js.map